import React from "react";
import "./index.scss";
import { useProducts } from "./../../context/ProductsContext";
import { Link } from "react-router-dom";
import { snakeCase } from "lodash";
import { useUser } from "../../context/UserContext";

function Categories() {
  const { categories } = useProducts();
  const { translate } = useUser();
  return (
    <div className="categoriesSection d-flex flex-wrap gap-3 gap-md-4">
      {categories?.map((cat) => (
        <Link
          to={`/products/${snakeCase(cat?.name)}`}
          key={`cat-item-${cat?.name}`}
          className="catItem"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),url(${cat?.image})`,
          }}
        >
          <div
            className="text h-100 d-flex justify-content-center align-items-center"
            data-text={translate(snakeCase(cat?.name))}
          >
            <div className="viewWrapper">
              <span>V</span>
              <span>I</span>
              <span>E</span>
              <span>W</span>
              <span>&nbsp;</span>
              <span> E</span>
              <span>Q</span>
              <span>U</span>
              <span>I</span>
              <span>P</span>
              <span>M</span>
              <span>E</span>
              <span>N</span>
              <span>T</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default Categories;
